export default __webpack_public_path__ + "static/media/stroller_supermarket.b96e7fb9.svg";